// extracted by mini-css-extract-plugin
export var posts = "blog-module--posts--p4vu7";
export var post = "blog-module--post--AganZ";
export var tags = "blog-module--tags--I8YRc";